import { render, staticRenderFns } from "./OrderNoteTooltip.vue?vue&type=template&id=8385a616&scoped=true"
import script from "./OrderNoteTooltip.vue?vue&type=script&lang=js"
export * from "./OrderNoteTooltip.vue?vue&type=script&lang=js"
import style0 from "./OrderNoteTooltip.vue?vue&type=style&index=0&id=8385a616&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8385a616",
  null
  
)

export default component.exports